"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _react2 = require("linaria/react");

var _Link = _interopRequireDefault(require("./Link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const SidebarContent =
/*#__PURE__*/
(0, _react2.styled)("aside")({
  name: "SidebarContent",
  class: "SidebarContent_s9nrg4n"
});
const Navigation =
/*#__PURE__*/
(0, _react2.styled)("nav")({
  name: "Navigation",
  class: "Navigation_nlggdah"
});
const Searchbar =
/*#__PURE__*/
(0, _react2.styled)("input")({
  name: "Searchbar",
  class: "Searchbar_s1nn5lbd"
});
const MenuContent =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "MenuContent",
  class: "MenuContent_mdzibsv"
});
const MenuIcon =
/*#__PURE__*/
(0, _react2.styled)("label")({
  name: "MenuIcon",
  class: "MenuIcon_m1mups47"
});
const MenuButton =
/*#__PURE__*/
(0, _react2.styled)("input")({
  name: "MenuButton",
  class: "MenuButton_mzfqg8l"
});
const LogoImage =
/*#__PURE__*/
(0, _react2.styled)("img")({
  name: "LogoImage",
  class: "LogoImage_llziuo3"
});
const SeparatorItem =
/*#__PURE__*/
(0, _react2.styled)("hr")({
  name: "SeparatorItem",
  class: "SeparatorItem_s1gpol2t"
});
const LinkItem =
/*#__PURE__*/
(0, _react2.styled)(_Link.default)({
  name: "LinkItem",
  class: "LinkItem_l5q2p2e"
});
const Row =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "Row",
  class: "Row_rl210no"
});
const GroupItems =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "GroupItems",
  class: "GroupItems_g1ol5l8s"
});
const ButtonIcon =
/*#__PURE__*/
(0, _react2.styled)("button")({
  name: "ButtonIcon",
  class: "ButtonIcon_b19yxlm8"
});

class Sidebar extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      query: '',
      open: false,
      expanded: this.props.data.reduce((acc, item) => {
        if (item.type === 'separator') {
          return acc;
        }

        if (item.group) {
          const group = acc[item.group];

          if (!group) {
            acc[item.group] = {
              height: null,
              expanded: true
            };
          }
        }

        return acc;
      }, {})
    });

    _defineProperty(this, "_measureHeights", () => this.setState({
      expanded: this.props.data.reduce((acc, item) => {
        if (item.type === 'separator') {
          return acc;
        }

        if (item.group) {
          const group = acc[item.group];
          const height = this._items[item.group] ? this._items[item.group].clientHeight : null;

          if (!group) {
            acc[item.group] = {
              height,
              expanded: true
            };
          }
        }

        return acc;
      }, {})
    }));

    _defineProperty(this, "_items", {});
  }

  componentDidMount() {
    setTimeout(() => this._measureHeights(), 1000);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this._measureHeights();
    }
  }

  render() {
    const {
      path,
      data,
      logo
    } = this.props;

    const mapper = (item, i) => {
      if (item.type === 'separator') {
        return React.createElement(SeparatorItem, {
          key: `separator-${i + 1}`
        });
      }

      if (item.type === 'group') {
        const groupItem = this.state.expanded[item.title] || {
          height: null,
          expanded: true
        };
        return React.createElement("div", {
          key: item.link || item.title + i
        }, React.createElement(Row, null, React.createElement(LinkItem, {
          "data-selected": path === item.link,
          to: item.link,
          onClick: () => this.setState(state => {
            const group = state.expanded[item.title];
            return {
              expanded: _objectSpread({}, state.expanded, {
                [item.title]: _objectSpread({}, group, {
                  expanded: path === item.link || !item.link ? !group.expanded : group.expanded
                })
              }),
              open: path === item.link ? state.open : false,
              query: ''
            };
          })
        }, item.title), React.createElement(ButtonIcon, {
          "data-expanded": groupItem.expanded,
          style: {
            opacity: typeof groupItem.height === 'number' ? 1 : 0
          },
          onClick: () => this.setState(state => {
            const group = state.expanded[item.title];
            return {
              expanded: _objectSpread({}, state.expanded, {
                [item.title]: _objectSpread({}, group, {
                  expanded: !group.expanded
                })
              })
            };
          })
        }, React.createElement("svg", {
          width: "16px",
          height: "16px",
          viewBox: "0 0 16 16"
        }, React.createElement("polygon", {
          stroke: "none",
          strokeWidth: "1",
          fillRule: "evenodd",
          fill: "currentColor",
          points: "8 4 2 10 3.4 11.4 8 6.8 12.6 11.4 14 10"
        })))), React.createElement(GroupItems, {
          ref: container => {
            this._items[item.title] = container;
          },
          "data-visible": !!groupItem.expanded,
          style: typeof groupItem.height === 'number' ? {
            height: `${groupItem.expanded ? groupItem.height : 0}px`
          } : null
        }, item.items.map(mapper)));
      }

      return React.createElement(LinkItem, {
        "data-selected": path === item.link,
        key: item.link,
        to: item.link,
        onClick: () => this.setState({
          open: false,
          query: ''
        })
      }, item.title);
    };

    let items;

    if (this.state.query) {
      items = data.filter(item => {
        if (item.type === 'separator') {
          return false;
        }

        return item.title.toLowerCase().includes(this.state.query.toLowerCase());
      });
    } else {
      // Find all groups names in our data and create a list of groups
      const groups = data.filter(item => Boolean(item.group)).map(item => item.group).filter((item, i, self) => self.lastIndexOf(item) === i).reduce((acc, title) => Object.assign(acc, {
        [title]: {
          type: 'group',
          items: [],
          title
        }
      }), {}); // Find items belonging to groups and add them to the groups

      items = data.reduce((acc, item) => {
        if (item.type === 'separator') {
          acc.push(item);
        } else if (item.title in groups) {
          // If the title of the item matches a group, replace the item with the group
          const group = groups[item.title];
          acc.push(_objectSpread({}, group, {
            link: item.link
          }));
        } else if (item.group) {
          // If the item belongs to a group, find an item matching the group first

          /* $FlowFixMe */
          const index = acc.findIndex(it => it.title === item.group);
          let group = acc[index];

          if (group) {
            if (group.type !== 'group') {
              // If the item exists, but is not a group, turn it a to a group first

              /* $FlowFixMe */
              group = _objectSpread({}, groups[item.group], {
                link: item.link
              });
              acc[index] = group;
            } else {
              // If the group exists, add our item
              group.items.push(item);
            }
          } else {
            // If the item doesn't exist at all, add a new group to the list

            /* $FlowFixMe */
            group = groups[item.group];
            group.items.push(item);
            acc.push(group);
          }
        } else {
          acc.push(item);
        }

        return acc;
      }, []);
    }

    const links = items.map(mapper);
    return React.createElement(SidebarContent, null, React.createElement(MenuButton, {
      id: "slide-sidebar",
      type: "checkbox",
      role: "button",
      checked: this.state.open,
      onChange: e => this.setState({
        open: e.target.checked
      })
    }), React.createElement(MenuIcon, {
      htmlFor: "slide-sidebar"
    }, "\u2630"), React.createElement(MenuContent, null, logo ? React.createElement(LogoImage, {
      src: logo,
      alt: "Logo"
    }) : null, React.createElement(Searchbar, {
      type: "search",
      value: this.state.query,
      onChange: e => this.setState({
        query: e.target.value
      }),
      placeholder: "Filter\u2026"
    }), React.createElement(Navigation, null, links)));
  }

}

exports.default = Sidebar;
//# sourceMappingURL=Sidebar.js.map

require('../css/src/templates/Sidebar.css');
